import store from '@/store'

const bookList = {
  namespaced: true,
  state: {
    mode: 'list', // モード(list: 一覧表示(ドリルダウン)モード、search: キーワード検索モード )
    packagesAndProductsAreaTreeData: {}, // パッケージ＆商品ツリーデータ
    packagesAndProductsAreaBooks: [], // 単体書籍リスト
    idMapListOfCheckedProducts: [], // チェックされている商品の商品IDと書籍IDのリスト（詳細から戻った時の復元用）
    selectedIdMapOfBooksArea: {}, // 書籍エリアで選択されている商品ID(product_id)＆書籍ID(book_id)

    bookId: 0, // 表示中の書籍ID（別ページから戻った時の復元用）（SPで使用）
    bookName: '', // 表示中の書籍名（別ページから戻った時の復元用）（SPで使用）

    mainListType: 'book', // 表示中のメインエリアのリストのタイプ（SP用）（book=書籍一覧エリア / contents=目次一覧エリア）
    targetNodeIdOfTableOfContents: 0 // 表示中の目次のノードID（別ページから戻った時の復元用）（SPで使用）
  },
  getters: {
  },
  mutations: {
    clearAll(state) {
      state.mode = 'list'
      state.packagesAndProductsAreaTreeData = {}
      state.packagesAndProductsAreaBooks = []
      state.idMapListOfCheckedProducts = []
      state.selectedIdMapOfBooksArea = {}
      state.bookId = 0
      state.bookName = ''
      state.mainListType = 'book'
      state.targetNodeIdOfTableOfContents = 0
    },
    setMode(state, mode) {
      state.mode = mode
    },
    setPackagesAndProductsAreaTreeData(state, packagesAndProductsAreaTreeData) {
      state.packagesAndProductsAreaTreeData = packagesAndProductsAreaTreeData
    },
    setPackagesAndProductsAreaBooks(state, packagesAndProductsAreaBooks) {
      state.packagesAndProductsAreaBooks = packagesAndProductsAreaBooks
    },
    setIdMapListOfCheckedProducts(state, idMapListOfCheckedProducts) {
      state.idMapListOfCheckedProducts = idMapListOfCheckedProducts
    },
    setSelectedIdMapOfBooksArea(state, selectedIdMapOfBooksArea) {
      state.selectedIdMapOfBooksArea = selectedIdMapOfBooksArea
    },

    setBookId(state, bookId) {
      state.bookId = bookId
    },
    setBookName(state, bookName) {
      state.bookName = bookName
    },

    setMainListType(state, mainListType) {
      state.mainListType = mainListType
    },
    setTargetNodeIdOfTableOfContents(state, targetNodeIdOfTableOfContents) {
      state.targetNodeIdOfTableOfContents = targetNodeIdOfTableOfContents
    }
  },
  actions: {
    // 全ステートをクリア
    clearAll({ commit }) {
      commit('clearAll')
    },
    // モード
    setMode({ commit }, mode) {
      commit('setMode', mode)
    },
    // パッケージ＆商品ツリーデータ（別ページから戻った時の復元用）
    setPackagesAndProductsAreaTreeData({ commit }, packagesAndProductsAreaTreeData) {
      commit('setPackagesAndProductsAreaTreeData', packagesAndProductsAreaTreeData)
    },
    // 単体書籍リスト（別ページから戻った時の復元用）
    setPackagesAndProductsAreaBooks({ commit }, packagesAndProductsAreaBooks) {
      commit('setPackagesAndProductsAreaBooks', packagesAndProductsAreaBooks)
    },
    // チェックされている商品の商品IDと書籍IDのリスト（詳細から戻った時の復元用）
    setIdMapListOfCheckedProducts({ commit }, idMapListOfCheckedProducts) {
      commit('setIdMapListOfCheckedProducts', idMapListOfCheckedProducts)
    },
    // 書籍エリアで選択されている商品ID(product_id)＆書籍ID(book_id)
    setSelectedIdMapOfBooksArea({ commit }, selectedIdMapOfBooksArea) {
      commit('setSelectedIdMapOfBooksArea', selectedIdMapOfBooksArea)
    },

    // 表示中の書籍ID（別ページから戻った時の復元用）（SPで使用）
    setBookId({ commit }, bookId) {
      commit('setBookId', bookId)
    },
    // 表示中の書籍名（別ページから戻った時の復元用）（SPで使用）
    setBookName({ commit }, bookName) {
      commit('setBookName', bookName)
    },

    // 表示中のメインエリアのリストのタイプ（SP用）（book=書籍一覧エリア / contents=目次一覧エリア）
    setMainListType({ commit }, mainListType) {
      commit('setMainListType', mainListType)
    },
    // 表示中の目次のノードID（別ページから戻った時の復元用）（SPで使用）
    setTargetNodeIdOfTableOfContents({ commit }, targetNodeIdOfTableOfContents) {
      commit('setTargetNodeIdOfTableOfContents', targetNodeIdOfTableOfContents)
    }
  }
}

export default bookList
